<template>
  <div>
    <h1>
      Esta integración aun no existe, solicítala al correo angelica@komercia.co
    </h1>
  </div>
</template>

<script>
export default {
  name: "integrationPage404",
};
</script>

<style></style>
